/**
 * Surrounding Area Configuration
 * Defines the taxonomy of items for each category
 */

export const surroundingAreaCategories = [
  {
    id: 'community-essentials',
    name: 'Community essentials',
    items: [
      { id: 'airport', name: 'Airport', requiresDistance: true, requiresName: true },
      { id: 'barber', name: 'Barber', requiresDistance: true },
      { id: 'brewery', name: 'Brewery', requiresDistance: true },
      { id: 'coffee-shop', name: 'Coffee shop', requiresDistance: true },
      { id: 'coworking-space', name: 'Coworking space', requiresDistance: true },
      { id: 'dry-cleaners', name: 'Dry cleaners', requiresDistance: true },
      { id: 'grocery-store', name: 'Grocery store', requiresDistance: true },
      { id: 'gym', name: 'Gym', requiresDistance: true },
      { id: 'restaurants', name: 'Restaurants', requiresDistance: true },
      { id: 'salon', name: 'Salon', requiresDistance: true },
      { id: 'shopping-mall', name: 'Shopping mall', requiresDistance: true },
      { id: 'yoga-studio', name: 'Yoga studio', requiresDistance: true },
    ],
  },
  {
    id: 'local-experiences',
    name: 'Local experiences',
    items: [
      { id: 'amusement-park', name: 'Amusement park', requiresDistance: true },
      { id: 'aquarium', name: 'Aquarium', requiresDistance: true },
      { id: 'art-gallery', name: 'Art gallery', requiresDistance: true },
      { id: 'childrens-museum', name: "Children's museum", requiresDistance: true },
      { id: 'farmers-market', name: "Farmer's market", requiresDistance: true },
      { id: 'hiking', name: 'Hiking', requiresDistance: true },
      { id: 'indoor-playground', name: 'Indoor playground', requiresDistance: true },
      { id: 'library', name: 'Library', requiresDistance: true },
      { id: 'movie-theater', name: 'Movie theater', requiresDistance: true },
      { id: 'museum', name: 'Museum', requiresDistance: true },
      { id: 'national-park', name: 'National park', requiresDistance: true },
      { id: 'outdoor-playground', name: 'Outdoor playground', requiresDistance: true },
      { id: 'public-pool', name: 'Public pool', requiresDistance: true },
      { id: 'rock-climbing', name: 'Rock climbing', requiresDistance: true },
      { id: 'science-center', name: 'Science center', requiresDistance: true },
      { id: 'skate-park', name: 'Skate park', requiresDistance: true },
      { id: 'skiing', name: 'Skiing', requiresDistance: true },
      { id: 'sport-course-fields', name: 'Sport course & fields', requiresDistance: true },
      { id: 'state-park', name: 'State park', requiresDistance: true },
      { id: 'trampoline-park', name: 'Trampoline park', requiresDistance: true },
      { id: 'zoo', name: 'Zoo', requiresDistance: true },
    ],
  },
  {
    id: 'learning-and-childcare',
    name: 'Learning and childcare',
    items: [
      { id: 'art-lessons', name: 'Art lessons', requiresDistance: true },
      { id: 'babysitter', name: 'Babysitter', requiresDistance: false },
      { id: 'day-camps', name: 'Day camps', requiresDistance: true },
      { id: 'daycare', name: 'Daycare', requiresDistance: true },
      { id: 'flexible-schools', name: 'Flexible schools', requiresDistance: true },
      { id: 'homeschool-groups', name: 'Homeschool groups', requiresDistance: false },
      { id: 'international-schools', name: 'International schools', requiresDistance: true },
      { id: 'library-programs', name: 'Library programs', requiresDistance: true },
      { id: 'makerspace', name: 'Makerspace', requiresDistance: true },
      { id: 'music-lessons', name: 'Music lessons', requiresDistance: true },
      { id: 'stem-lab', name: 'STEM Lab', requiresDistance: true },
      { id: 'tutoring', name: 'Tutoring', requiresDistance: true },
      { id: 'worldschool-meetups', name: 'Worldschool meetups', requiresDistance: false },
    ],
  },
  {
    id: 'health-and-medical',
    name: 'Health and medical',
    items: [
      { id: 'adult-dentist', name: 'Adult dentist', requiresDistance: true },
      { id: 'hospital', name: 'Hospital', requiresDistance: true, requiresName: true },
      { id: 'pediatric-dentist', name: 'Pediatric dentist', requiresDistance: true },
      { id: 'pediatrician', name: 'Pediatrician', requiresDistance: true },
      { id: 'pharmacy', name: 'Pharmacy', requiresDistance: true },
      { id: 'urgent-care', name: 'Urgent care', requiresDistance: true },
      { id: 'veterinarian', name: 'Veterinarian', requiresDistance: true },
    ],
  },
];

/**
 * Get category by ID
 */
export const getCategoryById = (categoryId) => {
  return surroundingAreaCategories.find(cat => cat.id === categoryId);
};

/**
 * Get item by category ID and item ID
 */
export const getItemByIds = (categoryId, itemId) => {
  const category = getCategoryById(categoryId);
  if (!category) return null;
  return category.items.find(item => item.id === itemId);
};

/**
 * Get all items for a category sorted A-Z
 */
export const getCategoryItems = (categoryId) => {
  const category = getCategoryById(categoryId);
  if (!category) return [];
  return [...category.items].sort((a, b) => a.name.localeCompare(b.name));
};

/**
 * Get label for named location field
 */
export const getNamedLocationLabel = (itemId) => {
  if (itemId === 'airport') return 'Nearest airport\'s name';
  if (itemId === 'hospital') return 'Nearest hospital\'s name';
  return null;
};
